import React from "react";

import SaleInformation, { Sale } from "./SaleInfo";
import ZeroSales from "./ZeroSales";
import SalesCardLoadingPlaceholder from "./SalesCardLoadingPlaceholder";
import SalesResultsContainer from "./SalesResultsContainer";
import { getDateForAPI } from "../utils/getDateForAPI";
import { useGetSales } from "../Hooks/useGetSales.hook";
import { shallowEqual, useSelector } from "react-redux";
import { StoreType } from "../../redux/store.types";

const SalesWithFetch = ({ day }: { day: Date }) => {
  const store = useSelector(
    (state: StoreType) => ({
      isToUseAuthZero: state.app.isToUseAuthZero,
    }),
    shallowEqual
  );

  const { data } = useGetSales(getDateForAPI(day), store.isToUseAuthZero);

  if (data && data.dayProgrammes[0].sales.length === 0) {
    return <ZeroSales></ZeroSales>;
  }

  if (!data) {
    return (
      <>
        <SalesCardLoadingPlaceholder></SalesCardLoadingPlaceholder>
        <SalesCardLoadingPlaceholder></SalesCardLoadingPlaceholder>
        <SalesCardLoadingPlaceholder></SalesCardLoadingPlaceholder>
      </>
    );
  }

  return (
    <SalesResultsContainer>
      {data &&
        data.dayProgrammes[0].sales.map((sale: Sale, index: number) => (
          <SaleInformation key={index} sale={sale} index={index} />
        ))}
    </SalesResultsContainer>
  );
};

export default SalesWithFetch;
